import { NEW_ORDER_ROUTE, ORDERS_ROUTE } from '@/shell/navigation.js';

/**
 * Where each Dashboard tile's call to action goes (MYP-27).
 *
 * What each tile *counts* is no longer guessed here: the counts are `readyToOrderCount`,
 * `awaitingPaymentCount` and `confirmReceiptCount` in `@mypoz/shared`, built on the same rules the
 * pages they link to already use (the vendor's `package_status_for_order_list` for Step 1, and
 * the order status groups for the Orders tabs). So a tile's number is the length of the list it
 * opens.
 *
 * The two order tiles open the Orders list already filtered to their tab (`?status=`, the same
 * parameter the tabs write), rather than the unfiltered list.
 */
export const DASHBOARD_TILE_ROUTES = {
  readyToOrder: NEW_ORDER_ROUTE,
  awaitingPayment: `${ORDERS_ROUTE}?status=unpaid`,
  confirmReceipt: `${ORDERS_ROUTE}?status=shipped`,
} as const;
